export const environment = {
  production: false,
  envName: 'test',
  scheme: 'https://',
  host: 'api-managment-digitalizcija.azure-api.net/responsys-app-dev', //test for now
  port: '',
  version: 1,
  subscription: '',
  hostURL:
    'https://api-managment-digitalizcija.azure-api.net/responsys-app-dev/',

  azureAd: {
    baseURL: 'https://content-rocket.test.valamar.hr/',
  },
  apiUrlNoApiM: 'https://wa-euwe-responsys-app-api-test-01.azurewebsites.net/',
  hub: 'https://api-managment-digitalizcija.azure-api.net/responsys-app-hub-dev/',
  apiScope: "api://d1a41434-2c53-4959-9c6b-81a711f69481/All"
};
